document.addEventListener("DOMContentLoaded", function () {
  let selects = document.querySelectorAll('.container-select .selected');

  selects.forEach(select => {
    select.addEventListener('click', function () {
      let container = this.parentNode;
      let seblings = container.querySelector('.list-filter');
      let height = seblings.scrollHeight;
      container.classList.toggle('active');

      if (container.classList.contains('active')) {
        seblings.style.height = height + 'px';
      } else {
        seblings.style.height = '0px';
      }
    })
  })
});

/**
 * @typedef {'Category' | 'Type' | 'Diet'} FilterKey
 */

/**
 * An object containing arrays of selected filters.
 * @type {Object.<FilterKey, string[]>}
 * @property {string[]} Category - The selected category filters.
 * @property {string[]} Type - The selected type filters.
 * @property {string[]} Diet - The selected diet filters.
 */
const selectedFilters = {
  Category: [],
  Type: [],
  Diet: [],
};

/**
 * Object containing filter parameters.
 * @type {Object.<FilterKey, string>}
 */
const filtersParams = {
  Category: "filter.p.m.custom.filter_category",
  Type: "filter.p.m.custom.filter_type",
  Diet: "filter.p.m.custom.filter_diet",
};
const COLLECTION_BASE_URL = "/collections/all";

/**
 * Stores the selected filters based on the filter type and value.
 *
 * @param {FilterKey} filterType - The type of filter.
 * @param {Object.<string, string>} selectedFilter - The value of the filter.
 */
function storeSelectedFilters(filterType, selectedFilter) {
  const storedFilters = selectedFilters[filterType].map(
    (filter) => filter.value
  );

  if (storedFilters.includes(selectedFilter.value)) {
    selectedFilters[filterType] = selectedFilters[filterType].filter(
      (filter) => filter.value !== selectedFilter.value
    );
  } else {
    selectedFilters[filterType].push(selectedFilter);
  }
}

/**
 * Updates the filter label based on the selected filters.
 * @param {FilterKey} filterType - The type of filter.
 * @returns {void}
 */
function updateFilterLabel(filterType) {
  const filterLabel = document.querySelector(
    `.filters-panel .filter-group[data-filter-name="${filterType}"] .selected`
  );

  if (selectedFilters[filterType].length === 1) {
    filterLabel.textContent = selectedFilters[filterType][0].label;
  } else if (selectedFilters[filterType].length > 1) {
    filterLabel.textContent = `${selectedFilters[filterType].length} selected`;
  } else {
    filterLabel.textContent = "ALL";
  }
}

/**
 * Handles the change event for a filter.
 *
 * @param {FilterKey} filterType - The type of filter.
 * @param {Object.<string, string>} selectedFilter - The value of the filter.
 * @returns {void}
 */
function handleFilterChange(filterType, selectedFilter) {
  storeSelectedFilters(filterType, selectedFilter);
  updateFilterLabel(filterType);
}

/**
 * Navigates to the page with selected filters applied.
 * @returns {void}
 */
function navigateToSelectedFilters() {
  const selectedFiltersParams = [];

  for (const [key, value] of Object.entries(selectedFilters)) {
    const values = value.map((filter) => filter.value);

    if (value.length > 0) {
      selectedFiltersParams.push(`${filtersParams[key]}=${values.join(",")}`);
    }
  }

  window.location.href = `/collections/all?${selectedFiltersParams.join("&")}`;
}

/**
 * Navigates to the page with empty filters.
 * @returns {void}
 */
function navigateToEmptyFilters() {
  window.location.href = "/collections/all";
}

/**
 * Populates the filter with initial values based on the given value and filter type.
 *
 * @param {string} value - The value to be used for populating the filter. It should be a comma-separated string of initial values.
 * @param {string} filterType - The type of filter to be populated.
 * @returns {void}
 */
function populateFilter(value, filterType) {
  const initialValues = value.split(",").map((initialValue) => {
    const labelElement = document.querySelector(
      `.filters-panel .filters-set input#${initialValue}`
    );
    const label = labelElement.getAttribute("name");

    return {
      label,
      value: initialValue,
    };
  });

  selectedFilters[filterType] = initialValues;
}

/**
 * Hydrates the selected filters based on the URL parameters.
 * @returns {void}
 */
function hydrateSelectedFilters() {
  /*
   * Hydration from URL
   */
  const urlParams = new URLSearchParams(window.location.search);
  const isSingleCollection = window.location.pathname !== "/collections/all";

  if (urlParams.size > 0) {
    const filterTypeMap = {
      [filtersParams.Category]: "Category",
      [filtersParams.Type]: "Type",
      [filtersParams.Diet]: "Diet",
    };

    for (const [key, value] of urlParams.entries()) {
      const filterType = filterTypeMap[key];

      if (filterType) {
        populateFilter(value, filterType);
      }
    }
  } else if (isSingleCollection) {
    /*
     * Hydration from Checked inputs (useful for Individual collections)
     */
    const filterGroups = document.querySelectorAll(
      ".filters-set > .filter-group"
    );

    filterGroups.forEach((group) => {
      const filterType = group.dataset.filterName;
      const checkedInputs = group.querySelectorAll("input:checked");

      if (checkedInputs) {
        checkedInputs.forEach((input) => {
          const value = input.getAttribute("id");
          const label = input.getAttribute("name");

          selectedFilters[filterType].push({
            value,
            label,
          });
        });
      }
    });
  }
}

/**
 * Renders the buttons when there are selected filters.
 * @returns {void}
 */
function renderButtons() {
  const applyFiltersButton = document.querySelector(
    ".filters-panel .go-to-filter"
  );
  const clearFiltersButton = document.querySelector(
    ".filters-panel .go-to-clear"
  );
  const filterHasValues = Object.values(selectedFilters).some(
    (value) => value.length > 0
  );

  if (filterHasValues) {
    applyFiltersButton.style.display = "inline-block";
    clearFiltersButton.style.display = "inline-block";

    applyFiltersButton.addEventListener("click", navigateToSelectedFilters);
    clearFiltersButton.addEventListener("click", navigateToEmptyFilters);
  } else {
    applyFiltersButton.style.display = "none";
    clearFiltersButton.style.display = "none";

    applyFiltersButton.removeEventListener("click", navigateToSelectedFilters);
    clearFiltersButton.removeEventListener("click", navigateToEmptyFilters);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const filtersPanel = document.querySelector(".filters-panel");
  const filterLists = filtersPanel.querySelectorAll(
    ".filters-panel .filter-group ul.list-filter"
  );

  if (filterLists.length > 0) {
    hydrateSelectedFilters();
    renderButtons();

    filterLists.forEach((filter) => {
      const filterType = filter.dataset.name;
      const filterOptions = filter.querySelectorAll("li input");


      updateFilterLabel(filterType);

      filterOptions.forEach((option) => {
        const isFilterSelected = selectedFilters[filterType].some(
          (filter) => filter.value === option.id
        );

        if (isFilterSelected) {
          option.checked = true;
        }

        option.addEventListener("click", function (event) {
          const selectedFilter = {
            label: event.target.name,
            value: event.target.id,
          };

          handleFilterChange(filterType, selectedFilter);
          renderButtons();
        });
      });
    });
  }
});
